/** @format */
import urlEditorTpl from './urlEditor.tpl.html';

export const urlEditorModule = 'sis-components.string.urlEditor';

(function () {
    angular.module(urlEditorModule, []).directive('urlEditor', urlEditorDirective).controller('urlEditorController', urlEditorController);

    function urlEditorDirective() {
        return {
            restrict: 'E',
            require: ['ngModel'],
            scope: {
                name: '@',
                required: '@',
                maxLength: '@',
                placeholder: '@',
            },
            template: urlEditorTpl,
            bindToController: true,
            controller: 'urlEditorController as $ctrl',
            link: function (scope, elem, attrs, ctrls) {
                function forcePrefix(modelValue) {
                    if (_.isNil(modelValue) || _.isEmpty(_.trim(modelValue))) {
                        return modelValue;
                    }

                    if (!/^(https?):\/\//i.test(modelValue)) {
                        return 'http://' + modelValue;
                    }
                    return modelValue;
                }

                if (_.isEmpty(attrs.name)) {
                    throw 'urlEditor directive: name attribute is required';
                }

                var $ctrl = scope.$ctrl;
                $ctrl.ngModel = ctrls[0];
                $ctrl.ngModel.$formatters.push(forcePrefix);
                $ctrl.ngModel.$parsers.push(forcePrefix);
                $ctrl.pattern = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
            },
        };
    }

    function urlEditorController() {
        var $ctrl = this;

        $ctrl.valueChanged = function () {
            $ctrl.ngModel.$setViewValue(angular.copy($ctrl.ngModel.$viewValue));
        };
    }
})();
